module.exports = __webpack_public_path__ + "img/tool-qa.1bd0a6c.webp";